"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestPasswordResetBodyToJSON = exports.RequestPasswordResetBodyFromJSONTyped = exports.RequestPasswordResetBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function RequestPasswordResetBodyFromJSON(json) {
    return RequestPasswordResetBodyFromJSONTyped(json, false);
}
exports.RequestPasswordResetBodyFromJSON = RequestPasswordResetBodyFromJSON;
function RequestPasswordResetBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'phoneNumber': !(0, runtime_1.exists)(json, 'phoneNumber') ? undefined : (0, _1.PhoneNumberBodyFromJSON)(json['phoneNumber']),
    };
}
exports.RequestPasswordResetBodyFromJSONTyped = RequestPasswordResetBodyFromJSONTyped;
function RequestPasswordResetBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'phoneNumber': (0, _1.PhoneNumberBodyToJSON)(value.phoneNumber),
    };
}
exports.RequestPasswordResetBodyToJSON = RequestPasswordResetBodyToJSON;
